module.exports = __webpack_public_path__ + "img/symbol_9.b2ef7d1a.png";